import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "guide-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoLabelControl = _resolveComponent("HakoLabelControl")!
  const _component_HakoMultiselect = _resolveComponent("HakoMultiselect")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.category.id === null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " Kategoriaa ei julkaista vielä tässä vaiheessa. "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HakoLabelControl, {
        label: "Nimi*",
        for: "nimi"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HakoInput, {
            name: "nimi",
            modelValue: _ctx.category.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_HakoLabelControl, {
        label: "Kuuluu kategoriaan (jätä tyhjäksi jos olet luomassa pääkategoriaa)",
        for: "kategoria"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HakoMultiselect, {
            name: "kategoria",
            "use-avatar": false,
            options: _ctx.cCategories,
            modelValue: _ctx.category.parentCategoryId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category.parentCategoryId) = $event))
          }, null, 8, ["options", "modelValue"])
        ]),
        _: 1
      }),
      (_ctx.category.parentCategoryId != null)
        ? (_openBlock(), _createBlock(_component_HakoLabelControl, {
            key: 0,
            label: "Järjestysnumero",
            for: "jarjestys"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_HakoInput, {
                modelValue: _ctx.category.orderIndex,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.category.orderIndex) = $event)),
                name: "jarjestys",
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.category.id !== null)
        ? (_openBlock(), _createBlock(_component_HakoLabelControl, {
            key: 1,
            label: "Julkaisu",
            for: "publish"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.category.published) = $event)),
                type: "checkbox",
                name: "publish"
              }, null, 512), [
                [_vModelCheckbox, _ctx.category.published]
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.category.id === null)
        ? (_openBlock(), _createBlock(_component_HakoButton, {
            key: 2,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewCategory())),
            class: "btn-success",
            "is-block": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Lisää")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_HakoButton, {
            key: 3,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveCategory())),
            class: "btn-primary",
            "is-block": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tallenna muokkaus")
            ]),
            _: 1
          }))
    ])
  ]))
}